module.exports = __webpack_public_path__ + "media/src/images/logos/mass-media/tintuk-672d29ffa46b211820f5ef47f0cd2ec4.png";